<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="{{id}}"
>
  <snelstart-ui-details-buttons>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [config]="this.config()">
      Opslaan
    </snelstart-ui-button>

      <snelstart-ui-button *ngIf="showButtonInfo(id)"
                           type="secondary"
                           (click)="this.showDialogInfo()">
          Toelichting
      </snelstart-ui-button>
  </snelstart-ui-details-buttons>

  <snelstart-ui-details-content>
    <snelstart-venture-fiscaal-feature-aangever *ngIf="id ==='Ontvanger'"></snelstart-venture-fiscaal-feature-aangever>
    <snelstart-venture-fiscaal-feature-akte *ngIf="id ==='Notariële akte'"></snelstart-venture-fiscaal-feature-akte>
    <snelstart-venture-fiscaal-feature-algemene-vragen *ngIf="id ==='Algemene vragen'"></snelstart-venture-fiscaal-feature-algemene-vragen>
    <snelstart-venture-fiscaal-feature-bor *ngIf="id ==='Bedrijfsopvolgingsregeling'"></snelstart-venture-fiscaal-feature-bor>
    <snelstart-venture-fiscaal-feature-belasting *ngIf="id ==='Schenkbelasting'"></snelstart-venture-fiscaal-feature-belasting>
    <snelstart-venture-fiscaal-feature-berekening *ngIf="id ==='Berekening'"></snelstart-venture-fiscaal-feature-berekening>
    <snelstart-venture-fiscaal-feature-conserverende-aanslag *ngIf="id ==='Conserverende aanslag'"></snelstart-venture-fiscaal-feature-conserverende-aanslag>
    <snelstart-venture-fiscaal-feature-contactpersoon *ngIf="id ==='Contactpersoon'"></snelstart-venture-fiscaal-feature-contactpersoon>
    <snelstart-venture-fiscaal-feature-contanten *ngIf="id ==='Contanten'"></snelstart-venture-fiscaal-feature-contanten>
    <snelstart-venture-fiscaal-feature-effecten *ngIf="id ==='Effecten'"></snelstart-venture-fiscaal-feature-effecten>
    <snelstart-venture-fiscaal-feature-kwijtscheldingen *ngIf="id ==='Kwijtscheldingen'"></snelstart-venture-fiscaal-feature-kwijtscheldingen>
    <snelstart-venture-fiscaal-feature-ondernemingen *ngIf="id ==='Ondernemingen'"></snelstart-venture-fiscaal-feature-ondernemingen>
    <snelstart-venture-fiscaal-feature-onroerende-zaken *ngIf="id ==='Onroerende zaken'"></snelstart-venture-fiscaal-feature-onroerende-zaken>
    <snelstart-venture-fiscaal-feature-overige-schenkingen *ngIf="id ==='Overige schenkingen'"></snelstart-venture-fiscaal-feature-overige-schenkingen>
    <snelstart-venture-fiscaal-feature-roerende-zaken *ngIf="id ==='Roerende zaken'"></snelstart-venture-fiscaal-feature-roerende-zaken>
    <snelstart-venture-fiscaal-feature-schenker *ngIf="id ==='Schenker'"></snelstart-venture-fiscaal-feature-schenker>
    <snelstart-venture-fiscaal-feature-schuldigerkenningen *ngIf="id ==='Schenking op papier'"></snelstart-venture-fiscaal-feature-schuldigerkenningen>
    <snelstart-venture-fiscaal-feature-uitkeringen *ngIf="id ==='Periodieke uitkeringen'"></snelstart-venture-fiscaal-feature-uitkeringen>
    <snelstart-venture-fiscaal-feature-vrijstellingen *ngIf="id ==='Vrijstellingen'"></snelstart-venture-fiscaal-feature-vrijstellingen>
    <snelstart-venture-fiscaal-feature-vruchtgebruik *ngIf="id ==='Vruchtgebruiken'"></snelstart-venture-fiscaal-feature-vruchtgebruik>
    <snelstart-venture-fiscaal-feature-voorkoming *ngIf="id ==='Voorkoming dubbele schenkbelasting'"></snelstart-venture-fiscaal-feature-voorkoming>
  </snelstart-ui-details-content>
</snelstart-ui-details>


<snelstart-ui-dialog-definition id="toelSB" title="Toelichting bij '{{id}}'"
                                size="lg"
                                [(visible)]="dialogInfoVisible">
    <snelstart-ui-dialog-body>

        <snelstart-venture-fiscaal-feature-tekst-sb-aangever
                *ngIf="this.id ==='Ontvanger'"></snelstart-venture-fiscaal-feature-tekst-sb-aangever>
        <snelstart-venture-fiscaal-feature-tekst-sb-akte
                *ngIf="this.id ==='Notariële akte'"></snelstart-venture-fiscaal-feature-tekst-sb-akte>
        <snelstart-venture-fiscaal-feature-tekst-sb-algemene-vragen
                *ngIf="this.id ==='Algemene vragen'"></snelstart-venture-fiscaal-feature-tekst-sb-algemene-vragen>
        <snelstart-venture-fiscaal-feature-tekst-sb-belasting
                *ngIf="this.id ==='Schenkbelasting'"></snelstart-venture-fiscaal-feature-tekst-sb-belasting>
        <snelstart-venture-fiscaal-feature-tekst-sb-berekening
                *ngIf="this.id ==='Berekening'"></snelstart-venture-fiscaal-feature-tekst-sb-berekening>
        <snelstart-venture-fiscaal-feature-tekst-sb-bor
                *ngIf="this.id ==='Bedrijfsopvolgingsregeling'"></snelstart-venture-fiscaal-feature-tekst-sb-bor>
        <snelstart-venture-fiscaal-feature-tekst-sb-conserverende-aanslag
                *ngIf="this.id ==='Conserverende aanslag'"></snelstart-venture-fiscaal-feature-tekst-sb-conserverende-aanslag>
        <snelstart-venture-fiscaal-feature-tekst-sb-contactpersoon
                *ngIf="this.id ==='Contactpersoon'"></snelstart-venture-fiscaal-feature-tekst-sb-contactpersoon>
        <snelstart-venture-fiscaal-feature-tekst-sb-contanten
                *ngIf="this.id ==='Contanten'"></snelstart-venture-fiscaal-feature-tekst-sb-contanten>
        <snelstart-venture-fiscaal-feature-tekst-sb-effecten
                *ngIf="this.id ==='Effecten'"></snelstart-venture-fiscaal-feature-tekst-sb-effecten>
        <snelstart-venture-fiscaal-feature-tekst-sb-kwijtscheldingen
                *ngIf="this.id ==='Kwijtscheldingen'"></snelstart-venture-fiscaal-feature-tekst-sb-kwijtscheldingen>
        <snelstart-venture-fiscaal-feature-tekst-sb-ondernemingen
                *ngIf="this.id ==='Ondernemingen'"></snelstart-venture-fiscaal-feature-tekst-sb-ondernemingen>
        <snelstart-venture-fiscaal-feature-tekst-sb-onroerende-zaken
                *ngIf="this.id ==='Onroerende zaken'"></snelstart-venture-fiscaal-feature-tekst-sb-onroerende-zaken>
        <snelstart-venture-fiscaal-feature-tekst-sb-overige-schenkingen
                *ngIf="this.id ==='Overige schenkingen'"></snelstart-venture-fiscaal-feature-tekst-sb-overige-schenkingen>
        <snelstart-venture-fiscaal-feature-tekst-sb-roerende-zaken
                *ngIf="this.id ==='Roerende zaken'"></snelstart-venture-fiscaal-feature-tekst-sb-roerende-zaken>
        <snelstart-venture-fiscaal-feature-tekst-sb-schenker
                *ngIf="this.id ==='Schenker'"></snelstart-venture-fiscaal-feature-tekst-sb-schenker>
        <snelstart-venture-fiscaal-feature-tekst-sb-schuldigerkenningen
                *ngIf="this.id ==='Schenking op papier'"></snelstart-venture-fiscaal-feature-tekst-sb-schuldigerkenningen>
        <snelstart-venture-fiscaal-feature-tekst-sb-uitkeringen
                *ngIf="this.id ==='Periodieke uitkeringen'"></snelstart-venture-fiscaal-feature-tekst-sb-uitkeringen>
        <snelstart-venture-fiscaal-feature-tekst-sb-voorkoming
                *ngIf="this.id ==='Voorkoming dubbele schenkbelasting'"></snelstart-venture-fiscaal-feature-tekst-sb-voorkoming>
        <snelstart-venture-fiscaal-feature-tekst-sb-vrijstellingen
                *ngIf="this.id ==='Vrijstellingen'"></snelstart-venture-fiscaal-feature-tekst-sb-vrijstellingen>
        <snelstart-venture-fiscaal-feature-tekst-sb-vruchtgebruikt
                *ngIf="this.id ==='Vruchtgebruiken'"></snelstart-venture-fiscaal-feature-tekst-sb-vruchtgebruikt>



        <!-- algemene informatie van Belastingdienst-->
        <div class="accordion" id="accordionExample">

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingMeer">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseMeer" aria-expanded="false" aria-controls="collapseMeer">
                        Meer fiscale informatie
                    </button>
                </h2>
                <div id="collapseMeer" class="accordion-collapse collapse" aria-labelledby="headingMeer"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        De Belastingdienst heeft online uitgebreide
                        informatie over de belastingregels rondom schenken en schenkbelasting beschikbaar.

                        <div class="space20"></div>

                        <snelstart-ui-button size="small" type="secondary"
                                             iconRight="arrow-up-right-from-square">

                                <a target="_blank"
                                   href="https://www.belastingdienst.nl/wps/wcm/connect/nl/schenken/">
                                    Fiscale informatie schenken en schenkbelasting
                                </a>

                        </snelstart-ui-button>
                    </div>
                </div>
            </div>
        </div>

    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button id="sluiten" type="primary" icon="check" btn-x>Afsluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
